import type { JSX } from 'solid-js';

export function WifiFields(props: {
  ssid: string;
  password: string;
  openNetwork: boolean;
  onSSID: (value: string) => void;
  onPassword: (value: string) => void;
  onOpenNetwork: (value: boolean) => void;
  legend?: JSX.Element;
  required?: boolean;
}): JSX.Element {
  return (
    <fieldset class="wifi-fields">
      {props.legend}
      <label>
        <span>Network name</span>
        <input
          autocomplete="off"
          required={props.required}
          value={props.ssid}
          onInput={(event) => props.onSSID(event.currentTarget.value)}
        />
      </label>
      <label>
        <span>Password</span>
        <input
          type="password"
          autocomplete="new-password"
          minlength={8}
          maxlength={63}
          required={props.required && !props.openNetwork}
          disabled={props.openNetwork}
          value={props.password}
          onInput={(event) => props.onPassword(event.currentTarget.value)}
        />
      </label>
      <label class="wifi-open-toggle">
        <input
          type="checkbox"
          checked={props.openNetwork}
          onChange={(event) => props.onOpenNetwork(event.currentTarget.checked)}
        />
        <span>Open network</span>
      </label>
    </fieldset>
  );
}
